// Split a command string into tokens.
// A command string looks like this:
// command arg1 "argument two" arg3
// The split function will return:
// ["command", "arg1", "argument two", "arg3"]
export function splitCommandString(command) {
  var tokens = [];
  var token = "";
  var inQuotes = false;
  for (var i = 0; i < command.length; i++) {
    var c = command[i];
    if (c == '"') {
      inQuotes = !inQuotes;
    } else if (c == " " && !inQuotes) {
      tokens.push(token);
      token = "";
    } else {
      token += c;
    }
  }
  if (token.length > 0) tokens.push(token);

  return tokens;
}
